// imports
import React from 'react';
import { useSelector } from 'react-redux';
import { ICON } from '../../assets';
import PrimaryButton from './primary';
import { selectUserQuests } from '../../repositories/store/slices';

// interfaces / types / consts
interface Props { onClick: () => void; isLoading: boolean }

// exports
export default function RefreshBtn(props: Props): JSX.Element {
  const { onClick, isLoading } = props;
  const { startId, claimId } = useSelector(selectUserQuests);
  // render
  return (
    <PrimaryButton
      text="Refresh"
      size="md-skinny"
      isLoading={isLoading}
      className="refresh-btn"
      leftIcon={ICON.REFRESH}
      disabled={isLoading || Boolean(startId) || Boolean(claimId)}
      onClick={onClick}
    />
  );
}
